function normalizeLearningHubCourse(course) {
  if (!course || typeof course !== 'object') return course

  const attrs = course.attributes
  if (!attrs || typeof attrs !== 'object') {
    return {
      ...course,
      instructor: course.instructor ?? '',
    }
  }

  const disciplines =
    course.disciplines ??
    attrs.disciplines ??
    (course.discipline ?? attrs.discipline
      ? [course.discipline ?? attrs.discipline]
      : [])

  return {
    ...course,
    ...attrs,
    id: course.id ?? attrs.id,
    title: course.title ?? attrs.title,
    description: course.description ?? attrs.description,
    coverImage: course.coverImage ?? attrs.coverImage ?? attrs.cover_image,
    category: course.category ?? attrs.category,
    discipline: course.discipline ?? attrs.discipline,
    disciplines: Array.isArray(disciplines) ? disciplines : [],
    instructor: course.instructor ?? attrs.instructor ?? '',
  }
}

function normalizeLearningHubCatalog(catalog) {
  if (!catalog || typeof catalog !== 'object') return catalog

  const groups = catalog.disciplineGroups || catalog.discipline_groups
  if (!Array.isArray(groups)) return catalog

  return {
    ...catalog,
    disciplineGroups: groups.map((group) => ({
      ...group,
      courses: (group.courses || []).map(normalizeLearningHubCourse),
    })),
  }
}

export { normalizeLearningHubCourse, normalizeLearningHubCatalog }
